import React, { Component } from 'react';
import { appService } from '../../_services';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom'

var AlignFlex = {
    alignSelf: 'flex-end'
}
var paddingButton = {
    paddingTop:'31px'
}
export class CitationSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchDetails: {
                volume: "",
                title: '',
                page: "",
                inNewTab: false
            },
            errors: {},
            result: [],
            items :[
                "David",
                "Damien",
                "Sara",
                "James",
                "Jane",
                "Sapiens"
            ],
            suggestions: [],
            text: ''
        }
       
        this.valueChange = this.valueChange.bind(this);
        this.GetCitation = this.GetCitation.bind(this);
        this.handleNewTabChange = this.handleNewTabChange.bind(this);
    }

    onTextChanged = (e) => {
        const value = e.target.value;
        let suggest = [];
        if (value.length > 0) {
            var self = this;
            var url = 'Product/GetCitationList?title=';            
            appService.getById(url, value)
                .then(function (data) {
                    data.map((item, key) => {
                        suggest.push(item.abbreviation);
                    }
                    );              
                    self.setState({ suggestions: suggest });                   
                });        
            //const regex = new RegExp(`^${value}`, 'i');
            //suggestions = this.state.items.sort().filter(v => regex.test(v));
        }
        this.setState(() => ({ text: value }));
    }

    suggestionSelected(value) {
        this.setState(() => ({
            text: value,
            suggestions: []
        }));
    }

    renderSuggestions() {
        const { suggestions } = this.state;
        if (suggestions.length === 0) {
            return null;
        }
        return (
            <div className="srchList">
                <ul>
                    {suggestions.map((item) => <li onClick={() => this.suggestionSelected(item)}>{item}</li>)}
                </ul>
            </div>
        );
    }



    handleNewTabChange(evt) {
        const { searchDetails } = this.state;
        this.setState({
            searchDetails: {
                ...searchDetails,
                inNewTab: evt.target.checked
            }
        });
    }

    valueChange(event) {
        const { name, value } = event.target;
        const { searchDetails } = this.state;
        this.setState({
            searchDetails: {
                ...searchDetails,
                [name]: value
            }
        });
    }

    validateForm() {

        let fields = this.state.searchDetails;
        let errors = {};
        let formIsValid = true;

        if (this.state.text == "") {
            formIsValid = false;
            errors["title"] = "* Title is required";
        }
        

        if (typeof fields["volume"] !== "undefined") {
            if (fields["volume"] != "" && !fields["volume"].match(/^[0-9]+$/)) {
                formIsValid = false;
                errors["volume"] = "* Only numbers are allowed";
            }
        }

        if (typeof fields["page"] !== "undefined") {
            if (fields["page"] != "" && !fields["page"].match(/^[0-9]+$/)) {
                formIsValid = false;
                errors["page"] = "* Only numbers are allowed";
            }
        }

        this.setState({
            errors: errors
        });

        return formIsValid;
    }

    GetCitation() {
        var self = this;
        var data = [];
        if (this.validateForm()) {

            var Parameters = {
                Volume: this.state.searchDetails.volume == "" ? 0 : this.state.searchDetails.volume,
                Page: this.state.searchDetails.page == "" ? 0 : this.state.searchDetails.page,
                Title: this.state.text, OpenNewTab: this.state.searchDetails.inNewTab
            }

            appService.submit('/Product/FindCitation', Parameters)
                .then(function (data) {
                    if (data != null) {
                        self.setState({ result: data });
                    }
                });
        }

        //let fields = {};
        //fields["volume"] = "";
        //fields["page"] = "";
        //fields["title"] = "";
        //this.setState({ fields: fields });
        //this.setState({ ShowError: false });

    }


render() {

    const { searchDetails, submitted } = this.state;
    const { text, result } = this.state;   

    let CitationResult = "";
    if (result != null && Object.keys(result).length > 0) {
        if (result.docId != "" && result.docId != null) {
            CitationResult = result.message == "" || typeof result.message == 'undefined' ? "journalarticle/" + result.title + "/" + result.volumeNo + "." + result.issueTextNo + "/" + result.docId
                : "journalarticle/" + result.title + "/" + result.volumeNo + "." + result.issueTextNo + "/" + result.docId;
         }
        else if (result.issueId != "" && result.issueId != null) {
            CitationResult = result.message == "" || typeof result.message == 'undefined' ? "journalIssue/" + result.title + "/" + result.volumeNo + "." + result.issueTextNo + "/" + result.issueId
                : "journalIssue/" + result.title + "/" + result.volumeNo + "." + result.issueTextNo + "/" + result.issueId ;

         }
         else {
            CitationResult = result.message == "" || typeof result.message == 'undefined' ? "Journals/" + result.title + "/" + result.prodId
                                                   : "Journals/" + result.title + "/" + result.prodId ;
        }

        if (result.message == "" || typeof result.message == 'undefined') {
            return <Redirect to={CitationResult} />
            //window.location.href = window.location.host + CitationResult;
        }
    }
        
        
    return (

        <div>
            <div className="col-12">
                <div className="row">
                    <div className="col-lg-9 margintop">
                        <h1><p className="TitlePadding Title">Citation Search</p></h1>
                    </div>
                </div>
                <div class="row"><div class="White"></div></div>
                <div className="row">
                    <div className="col-lg-2 colPadding">
                        <label for="volume">Volume (or Year)</label>
                        <input class="form-control RefineListWords" id="volume" type="text" placeholder="e.g. 44 or 2019" name="volume" value={searchDetails.volume} onChange={this.valueChange} />
                        <div className="errorMsg">{this.state.errors.volume}</div>
                    </div>
                    <div className="col-lg-4">
                        <label for="title">Title (or title abbreviation) </label>
                        <input class="form-control RefineListWords" id="title" name="title" value={this.state.text} onChange={this.onTextChanged} type="text" placeHolder="e.g. Air & Space Law or ASL" />
                        <div className="errorMsg">{this.state.errors.title}</div>
                    </div>
                    <div className="col-lg-2">
                        <label for="page">Page number</label>
                        <input class="form-control RefineListWords" id="page" name="page" type="text" placeholder="e.g. 24" value={searchDetails.page} onChange={this.valueChange} />
                        <div className="errorMsg">{this.state.errors.page}</div>
                    </div>
                            <div className="col-lg-2" style={this.state.errors.title == "" ? AlignFlex: paddingButton}>
                        <button type="button" className="btn next float-left rounded-0 setpadastextbox" onClick={this.GetCitation} >Find citation</button>
                    </div>


                </div>
                <div class="row"><div class="White"></div></div>
                <div className="row">
                    <div class="col-lg-2"></div>
                    <div className="col-lg-4 justify-content-md-center">
                        {this.renderSuggestions()}
                    </div>
                    <div class="col-lg-4" style={{ display: "none" }}>
                        <div className="square"><input type="checkbox" id="information" onChange={this.handleNewTabChange} />
                            <label for="information"></label>
                            <span style={{ paddingLeft: '6%' }}> Open in new tab </span>
                        </div>
                    </div>
                </div>

                <div class="row">
                            <div class="col-lg-2"></div>
                           
                            <div className={CitationResult != '' && CitationResult != null ? "justify-content-md-center URLResult" : "col-lg-4 justify-content-md-center"}>                                
                                {result.message != "" && typeof result.message != 'undefined' ?
                                    <p>{result.message}</p>
                                    : null
                                }
                                <Link to={CitationResult} target="_blank" className="LinkClass">{CitationResult != '' && CitationResult != null ? window.location.host + "/" + CitationResult : null}</Link>
                            </div>
                </div>

                <div class="row"><div class="White"></div></div>
                <div class="row"><div class="White"></div></div>
                <div class="row"><div class="White"></div></div>
            </div>


           

        </div>
    )
}
}




// WEBPACK FOOTER //
// ./src/components/Home/CitationSearch.jsx